import Backbone from 'backbone';

import { deepClone } from '@luna/utils';
import { getEnv } from '@luna/env';
import { updateDeprecatedUserConfiguration } from '@shared/user-configuration';
import { request } from '@luna/api';

export class UserConfigurationModel extends Backbone.Model {
    defaults() {
        return {
            redTransactions: false,
            addressbook: undefined,
            consumerLoanConfig: undefined,
            bundleInfoShown: false,
            setupShown: false,
            overview: undefined,
            topProducts: undefined,
            language: '',
            upcomingLookahead: undefined,
            trading: undefined,
            pfm: undefined,
            sIDAvailableNotificationShown: false,
            overviewChartScaling: false,
            soundEnabled: false,
            firstVisit: {},
        };
    }

    url() {
        return `${getEnv().georgeApiUrl}my/configuration/${this.id}`;
    }

    // @ts-expect-error ignore override
    sync(_method: any, model: UserConfigurationModel, _options: any) {
        let method = _method;
        const options = _options;

        if (method === 'update') method = 'create'; // turns GET into POST for saving

        if (method === 'create' || method === 'patch') {
            options.beforeSend = (xhr: any, _settings: any) => {
                const settings = _settings;

                // Filter out internal Fields to prevent funky behaviour
                const dataObj = JSON.parse(settings.data);

                // Delete the ID otherwise it will be saved in key/value store
                delete dataObj.id;

                settings.data = JSON.stringify(dataObj);
            };
        }

        const { id, ...fieldsToSend } = this.attributes;
        return updateDeprecatedUserConfiguration({ id, changes: deepClone(fieldsToSend), options });
    }

    fetchSuccess(userConfigurationFrontend: any, options: any) {
        this.set(userConfigurationFrontend);
        this.trigger('sync', this);
        if (options?.success) {
            options.success();
        }
    }

    async saveSubObject(objectName: any, cb?: any) {
        const subObj = this.get(objectName);

        if (subObj) {
            await request(`${this.url()}/${objectName}`, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: subObj,
            })
                .then(() => {
                    if (typeof cb === 'function') cb();
                })
                .catch((err) => {
                    if (typeof cb === 'function') cb(err);
                });
        }
    }
}
